/**
 * PATH: packages/ui/src/table/SortIcon.tsx
 * FILE_ID: UI-TABLE-SORTICON-001
 * PURPOSE: The sort-direction glyph, on the People directory contract.
 * WHY: The unsorted glyph is always rendered, never hover-revealed. Sixteen
 *      production tables showed nothing at all until you clicked, so sortable
 *      columns were indistinguishable from fixed ones on a touch device where
 *      there is no hover to reveal anything.
 * RELATED: SortableTableHeader.tsx
 */
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'

import type { SortDir } from './types'

/**
 * Active arrows carry no colour class: they inherit `currentColor` from the
 * header button, so the indicator tracks hover and theme without a per-hub
 * accent. Six different accent colours were in production before this.
 */
export function SortIcon({ dir }: { dir: SortDir | null }) {
  if (dir === null) {
    return <ChevronsUpDown className="h-3 w-3 opacity-40" aria-hidden="true" />
  }
  return dir === 'asc'
    ? <ArrowUp className="h-3 w-3" aria-hidden="true" />
    : <ArrowDown className="h-3 w-3" aria-hidden="true" />
}
